export default {
  namespaced: true,
  state: {
    inputBlur: false,// 输入框是否获取焦点
    showGiftPopup: false, //送礼品弹窗展示
    chartList: [],//聊天列表
    canScrollChart: true,//是否自动滚动聊天列表
    liveAction: false,//直播是否开始
    memberNum: 0,//观看直播人数
    memberHeaderList: [],//头像列表
    rewardGiftList: [],//打赏列表
    swiperList: [],//轮播图列表
    swiperIndex: '',//轮播图下标（结束后跳转）
  },
  mutations: {
    setSwiperEndInfo (state, value) {
      state.swiperList.forEach(item => {
        if (item.actionCutting === value.id) {
          item.endInfo = value.info
        }
      });
      state.swiperIndex = value.id
    },
    setSwiperIndex (state, value) {
      state.swiperIndex = value
    },
    setSwiperList (state, value) {
      state.swiperList = value
    },
    setLiveAction (state, value) {
      state.liveAction = value
    },
    setRewardGiftList (state, value) {
      state.rewardGiftList.push(value)
    },
    delRewardGiftList (state, value) {
      state.rewardGiftList.shift()
    },
    setMemberHeaderList (state, value) {
      state.memberHeaderList = value
    },
    setMemberNum (state, value) {
      state.memberNum = value
    },
    setScrollChart (state, value) {
      state.canScrollChart = value
    },
    setInputBlur (state, value) {
      state.inputBlur = value
    },
    setChartList (state, value) {
      if (state.chartList.length < 100) {
        state.chartList.push(value)
      } else {
        state.chartList.shift()
        state.chartList.push(value)
      }
    },
    setShowGiftPopup (state, value) {
      state.showGiftPopup = value
    }
  },
  actions: {
    setRewardGiftList ({ commit }, value) {
      commit('setRewardGiftList', value)
    },
    setSwiperIndex ({ commit }, value) {
      commit('setSwiperIndex', value)
    }
  },
  getters: {
  }
}



// WEBPACK FOOTER //
// ./src/starcharge/pages/activity/liveBroadcast/storeMod.js